export default __webpack_public_path__ + "assets/facebook-on.d649d79f.png";